import React from 'react';
import { useUserGetEmployeeAvailabilityForDate } from 'api/user/user';
import TextButton from 'components/inputs/TextButton';
import useModalStack from 'contexts/modal/useModalStack';
import { Badge } from 'pages/Employees/Availability';
import AvailabilityFormModal from 'pages/Employees/Availability/AvailabilityFormModal';
import { AvailabilityDto as LegacyAvailabilityDto, UserModel } from 'api/model';
import { adjustDateToNoon } from 'utils/date-helpers';

type Props = {
  user?: UserModel;
  userId?: number;
  date: Date;
};

const CaseAssignmentAvailabilityWidget: React.FC<Props> = ({
  user,
  userId,
  date,
}) => {
  const modalStack = useModalStack();

  const noonDate = adjustDateToNoon(date)!;

  const availabilityCall = useUserGetEmployeeAvailabilityForDate(
    {
      userId: user?.userID ?? userId,
      date: noonDate,
    },
    {
      query: {
        enabled: !(user === undefined && userId === undefined),
      },
    }
  );

  const showModal = () => {
    if (availabilityCall.data && (user || userId)) {
      modalStack.push(
        <AvailabilityFormModal
          availability={availabilityCall.data as LegacyAvailabilityDto}
          name={user?.name ?? ''}
          onClose={() => modalStack.pop()}
          onSaved={() => {
            availabilityCall.refetch();
            modalStack.pop();
          }}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          userId={(user?.userID ?? userId)!}
          viewOnly
          allowBookingRestrictions
        />
      );
    }
  };

  if (!user && !userId) {
    return null;
  }

  return (
    <TextButton onClick={showModal} title="Antal uppdrag denna dag">
      <Badge>{availabilityCall.data?.bookedAssignments ?? 0}</Badge>
    </TextButton>
  );
};

export default CaseAssignmentAvailabilityWidget;
